<template>
  <div
    class="contactsListColumn"
    :class="{
      contactsListColumnExpanded: $store.state.display.leftColumn.newConversation.isExpanded,
      contactsListColumnCollapsed: !$store.state.display.leftColumn.newConversation.isExpanded
    }"
  >
    <div class="transitionContainer">
      <transition-group class="transitionContainerInner" :name="$store.state.display.leftColumn.newConversation.stateTransition" tag="div" mode="out-in">
        <ContactsList v-show="$store.state.display.leftColumn.newConversation.viewState == 'contactList'" key="contactList" />
        <NewGroupAddContact v-show="$store.state.display.leftColumn.newConversation.viewState == 'newGroupAddContact'" key="newGroupAddContact" />
        <NewGroupInfoInput v-show="$store.state.display.leftColumn.newConversation.viewState == 'newGroupInfoInput'" key="NewGroupInfoInput" />
      </transition-group>
    </div>
  </div>
</template>

<script>
import EventBus from '@/eventbus.js'
import NewGroupInfoInput from './NewGroupInfoInput.vue'
import NewGroupAddContact from './NewGroupAddContact.vue'
import ContactsList from './ContactsList.vue'
export default {
  methods: {
    createNewGroup() {
      this.$store.commit('resetNewGroupParticipants')
      this.$store.commit('setNewConversationStateTransition', 'slideLeft')
      this.$store.commit('setNewConversationViewState', 'newGroupAddContact')
    }
  },
  components: {
    ContactsList,
    NewGroupAddContact,
    NewGroupInfoInput
  },

  mounted() {
    EventBus.$on('createNewGroupClicked', this.createNewGroup)
  }
}
</script>

<style lang="less" scoped>
.transitionContainer {
  position: relative;
  height: calc(100% - 0px);
  overflow: hidden;
}

.transitionContainerInner {
  height: calc(100% - 0px);
}
</style>

<style scoped>
.contactsListColumn {
  height: calc(100% - 0px);
  background-color: white;
  position: absolute;
  top: 0px;
  width: 100%;
  left: -100%;
  z-index: 1000;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.contactsListColumnExpanded {
  left: 0px;
  transition: left 0.3s;
}

.contactsListColumnCollapsed {
  left: -100%;
  width: 100%;
  transition: left 0.3s;
}
</style>
